import {useLazyQuery} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import type {Prompt} from '@cp/model';
import {GENERATE_STUDY_PROMPTS} from '../sharedQueries';

export interface GenerateStudyPromptsVariables {
  moduleId: string;
  topic: string;
  additionalInfo?: string;
}

export function useGenerateStudyPrompts() {
  const [generatePromptsQuery, {loading, error}] = useLazyQuery<
    {generateStudyPrompts: Prompt},
    GenerateStudyPromptsVariables
  >(GENERATE_STUDY_PROMPTS);

  const generateStudyPrompts = async (variables: GenerateStudyPromptsVariables) => {
    const result = await generatePromptsQuery({variables});
    return extractGqlData(result).generateStudyPrompts;
  };

  return {
    generateStudyPrompts,
    loading,
    error,
  };
}
